import {
  Datagrid,
  LanguageMessageInput,
  LongTextField,
} from "ra-friendsofbabba";
import {
  DeleteButton,
  EditButton,
  List as RaList,
  TextField,
} from "react-admin";

import Filters from "./Filters";
import React from "react";

const List = (props) => (
  <RaList
    {...props}
    exporter={false}
    filters={<Filters />}
    filterDefaultValues={{
      translated: false,
    }}
    sort={{ field: "id", order: "DESC" }}
  >
    <Datagrid>
      <TextField source="id" label="ID" />
      <LongTextField label="Language" source="language.name" />
      <LanguageMessageInput source="text" color="textSecondary" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </RaList>
);
export default List;
